import { fetchConsoleStoreRankDetailsCountriesRanks } from '@/pages/intelligence/services/storeRank';

import type { IRegionValue } from '@/pages/intelligence/types/common';
import type { IStoreRankDetailsCountriesRanks } from '@/pages/intelligence/types/storeRank';

export const fetchConsoleStoreRankDetailsCountriesRanksPlus = async (params: {
  edition_id: string;
  source: string[];
  markets: IRegionValue;
  end_date: string;
}) => {
  const result: IStoreRankDetailsCountriesRanks[] = [];
  try {
    const res = await fetchConsoleStoreRankDetailsCountriesRanks(params);
    const list = res?.data ?? [];
    for (const item of list) {
      const market = item?.market ?? '';
      const marketName = item?.name ?? '';
      const marketRank = item?.rank ?? Number.NaN;
      const countryRank: IStoreRankDetailsCountriesRanks = {
        countryCode: market,
        countryName: marketName,
        ranks: [
          {
            rankCode: 'rank',
            rankName: '',
            rankValue: marketRank,
          },
        ],
      };
      result.push(countryRank);
    }
  } catch (exception) {
    console.warn(exception);
  }
  return result;
};
